export const PLACEHOLDER = 'Search events, providers, courses, ...';
